/* DSL Compare-share — encode compare-set in URL hash, importable */
(function(){
  if (!window.DSL_COMPARE) return;
  document.addEventListener("click", function(e){
    if (!e.target.matches("[data-compare-share]")) return;
    e.preventDefault();
    var arr = window.DSL_COMPARE.get();
    if (!arr.length) return;
    var u = location.origin + "/pages/compare#" + btoa(JSON.stringify(arr));
    if (navigator.share) navigator.share({title: "Vergelijk producten", url: u}).catch(function(){});
    else navigator.clipboard.writeText(u).then(function(){ if (window.DSL_BANNER) window.DSL_BANNER.show({text: "Compare-link gekopieerd!", variant: "success"}); });
    if (window.DSL_AB) window.DSL_AB.track("compare_share", {n: arr.length});
  });
  // Auto-import on page load if hash present
  if (location.pathname.indexOf("/pages/compare") !== -1 && location.hash) {
    try {
      var arr = JSON.parse(atob(location.hash.slice(1)));
      if (Array.isArray(arr) && window.DSL_COMPARE) {
        arr.forEach(function(h){ if (window.DSL_COMPARE.get().indexOf(h) < 0) window.DSL_COMPARE.toggle(h); });
      }
    } catch(e){}
  }
})();